import React from "react";
import LegalLayout from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" updated="April 26, 2026">
      <p>
        We use cookies sparingly — only what is necessary to keep you signed in and to deliver the service.
      </p>

      <h2>1. What cookies we set</h2>
      <ul>
        <li>
          <strong>session_token</strong> — HTTP-only, Secure, SameSite cookie used to keep you authenticated for 7 days after sign-in. Contains a random opaque token; no personal data.
        </li>
      </ul>
      <p>That's it. We do not currently set any advertising, analytics, or third-party tracking cookies.</p>

      <h2>2. Third-party cookies</h2>
      <p>
        Google OAuth may briefly set cookies during the sign-in redirect flow. These are governed by Google's own cookie policy. Razorpay may set transactional cookies during payment — governed by Razorpay's policies.
      </p>

      <h2>3. Managing cookies</h2>
      <p>
        You can clear cookies anytime via your browser settings. Signing out of Jingle Hooks (top-right menu) deletes the session_token cookie immediately.
      </p>

      <h2>4. Analytics (future)</h2>
      <p>
        If we introduce privacy-first analytics (e.g., Plausible, Fathom), we will update this policy at least 14 days before enabling them. We will never use ad-retargeting cookies.
      </p>

      <h2>5. Contact</h2>
      <p>
        Questions? Email <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a>.
      </p>
    </LegalLayout>
  );
}
